import { render, staticRenderFns } from "./dns_lookup.vue?vue&type=template&id=2ad0fdbe&"
import script from "./dns_lookup.vue?vue&type=script&lang=js&"
export * from "./dns_lookup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./dns_lookup.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(component)

export default component.exports